import SizedTrack from './SizedTrack'

const measureGridSize = (trackSizes: SizedTrack[]): number =>
  trackSizes
    .map(track => track.exactSize)
    .reduce((sum, currentContribution) => sum + currentContribution, 0)

export default measureGridSize
